import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const values = [
  { icon: 'ri-leaf-line', title: '轻松优先', desc: '所有内容都以「减压、好笑、看得轻松」为核心，拒绝沉重与焦虑。' },
  { icon: 'ri-fire-line', title: '持续更新', desc: '人气短篇每日更新，热门分类实时补齐，让追更这件事变得省心。' },
  { icon: 'ri-heart-line', title: '内容真诚', desc: '坚持原创与有趣，不堆砌、不注水，每一篇都值得你花几分钟。' },
  { icon: 'ri-smartphone-line', title: '随处可看', desc: '电脑、平板、手机全适配，通勤睡前摸鱼随时随地快看。' },
];

const milestones = [
  { year: '2022', title: '出发', desc: '以「碎片时间快看」为起点，开始连载第一批短篇日常漫画。' },
  { year: '2024', title: '成长', desc: '内容覆盖六大分类，累计连载 200+ 篇，收获了一批忠实读者。' },
  { year: '2026', title: '陪伴', desc: '持续打磨内容与阅读体验，陪你轻松度过每一个碎片时刻。' },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 · 品牌介绍与发展理念 | 韩国歪歪漫画';
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <section className="bg-background-100 pt-24 pb-8 md:pt-32 md:pb-10">
        <div className="mx-auto max-w-4xl px-4 md:px-6">
          <nav className="text-xs text-foreground-600" aria-label="面包屑">
            <ol className="flex flex-wrap items-center gap-1">
              <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li className="text-foreground-900">关于我们</li>
            </ol>
          </nav>
          <h1 className="mt-4 font-heading text-4xl text-foreground-950 md:text-5xl">关于歪歪漫画</h1>
          <p className="mt-4 text-base leading-relaxed text-foreground-700 md:text-lg">
            我们相信，忙碌生活里最珍贵的，是那些能让你停下来笑一笑的几分钟。
            韩国歪歪漫画专注短篇搞笑日常内容，让摸鱼、睡前、通勤的碎片时间，都变成一刷就停不下来的轻松时刻。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">我们的定位</h2>
            <p className="mt-4 leading-relaxed text-foreground-800">
              歪歪漫画是一个面向年轻人的短篇漫画内容平台。我们不追求宏大的叙事，只专注把每一件生活小事画得有趣、真实、有共鸣。
            </p>
            <p className="mt-3 leading-relaxed text-foreground-700">
              从职场摸鱼到睡前治愈，从通勤解闷到沙雕脑洞，我们用轻松的画风和密集的笑点，陪伴你度过每一个碎片时刻，随时找到属于自己的轻松入口。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/comics" className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap">
                去逛逛漫画
              </Link>
              <Link to="/contact" className="inline-flex items-center gap-2 rounded-full bg-background-100 px-7 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200 whitespace-nowrap">
                和我们聊聊
              </Link>
            </div>
          </div>
          <div className="overflow-hidden rounded-3xl">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20friendly%20cartoon%20scene%20of%20young%20creative%20team%20drawing%20comics%20together%2C%20chibi%20style%20characters%2C%20orange%20cream%20and%20teal%20palette%2C%20playful%20and%20cozy%20webtoon%20illustration%2C%20happy%20relaxed%20atmosphere&width=1200&height=900&seq=about-team&orientation=landscape"
              alt="歪歪漫画编辑部创作场景插画"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="bg-background-100/70 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <h2 className="text-center font-heading text-3xl text-foreground-950 md:text-4xl">我们坚持的内容原则</h2>
          <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v) => (
              <div key={v.title} className="rounded-2xl border border-background-200 bg-background-50 p-6 text-center">
                <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-accent-100 text-accent-700">
                  <i className={`${v.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-4 font-medium text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <h2 className="text-center font-heading text-3xl text-foreground-950 md:text-4xl">一路走来的足迹</h2>
        <div className="mx-auto mt-10 grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-3">
          {milestones.map((m) => (
            <div key={m.year} className="relative rounded-2xl border border-background-200 bg-background-100/70 p-6">
              <span className="inline-block rounded-full bg-primary-500 px-4 py-1 text-sm font-medium text-background-50">{m.year}</span>
              <h3 className="mt-3 font-heading text-xl text-foreground-950">{m.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{m.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-accent-500 py-14 md:py-20">
        <div className="mx-auto max-w-4xl px-4 text-center">
          <h2 className="font-heading text-3xl text-background-50 md:text-4xl">读者的一句话，就是我们坚持的理由</h2>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-3">
            {[
              { num: '300+', label: '连载短篇' },
              { num: '每日更新', label: '轻松追更' },
              { num: '100%', label: '免费快看' },
            ].map((s) => (
              <div key={s.label} className="rounded-2xl bg-background-50 p-6">
                <div className="font-heading text-3xl text-primary-600">{s.num}</div>
                <div className="mt-1 text-sm text-foreground-700">{s.label}</div>
              </div>
            ))}
          </div>
          <div className="mt-8">
            <Link to="/contact" className="inline-flex items-center gap-2 rounded-full bg-background-50 px-8 py-3 text-sm font-medium text-accent-700 transition-transform hover:scale-105 whitespace-nowrap">
              联系我们 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}